module.exports = __webpack_public_path__ + "img/way_h.c96d10bf.png";